import {
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_SUCCESS,
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_END,
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_START,
} from '../actions/actions'
import dotProp from 'dot-prop-immutable-chain'

export default function eventsList(state = {}, action) {
  switch (action.type) {
    case FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_START:
      return dotProp(state)
        .set('aSyncCall', true)
        .value()

    case FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_END:
      return dotProp(state)
        .set('aSyncCall', false)
        .value()

    case FETCH_QUESTION_LIST_FOR_EVENT_MAKER_SUCCESS:
      return dotProp(state)
        .set(`questionsByTopic.${action.topicId}`, action.questions)
        .set(`questionsByTopic.${action.topicId}.count`, action.count)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/testMakerQuestionsCache.js